<template>
  <div>
    <v-tabs
      light
      fixed-tabs
      v-model="activeTab"
      slider-color="primary"
      show-arrows
    >
      <v-tab
        v-for="item in availableOptions"
        :key="item.label"
        :href="'#' + item.label"
      >
        <v-img
          :src="item.lender.logoSvg"
          :max-height="item.lender.maxHeight"
          max-width="100px"
          contain
        >
        </v-img>
      </v-tab>
      <v-tabs-items>
        <v-tab-item
          class="px-1 py-3"
          v-for="item in availableOptions"
          :key="item.label"
          :value="item.label"
        >
          <v-card>
            <v-card-text class="pa-2">
              <LenderListTile
                :subtitle="currentLender.name"
                :merchantId="item.merchantId"
              />
            </v-card-text>
          </v-card>
          <v-card v-if="currentLender.features">
            <v-card-text class="feature">
                <v-layout v-for="feature in currentLender.features" :key="feature">
                  <v-flex xs1>
                    <!--TODO Update if we're keeping the diff colored checkmarks -->
                    <v-icon v-if="currentLender.name==='Prime Lender for all Home Improvement needs.'" :color="currentLender.color">checkmark</v-icon>
                    <v-icon v-else-if="currentLender.name==='Affordable Second Look Option'" :color="currentLender.color">checkmark</v-icon>
                    <v-icon v-else-if="currentLender.name==='A smart alternative to traditional credit-based financing.'" :color="currentLender.color">checkmark</v-icon>
                    <v-icon v-else-if="currentLender.name==='Superprime to the deep sub-prime, multi-lender solution, with instant approvals.'" :color="currentLender.color">checkmark</v-icon>
                    <v-icon v-else-if="currentLender.name==='Commercial Business Financing made easy.'" :color="currentLender.color">checkmark</v-icon>
                    <v-icon v-else-if="currentLender.name==='Residential financing for any home improvement project'" :color="currentLender.color">checkmark</v-icon>
                  </v-flex>
                  <v-flex class="text-xs-left">
                    <span class="feature">{{ feature }}</span>
                  </v-flex>
                </v-layout>
                <p class="text-xs-left pt-4" v-if="currentLender.name==='Commercial Business Financing made easy.'" v-html="currentLender.description[0]"></p>
            </v-card-text>
          </v-card>
          <v-card v-if="showGreenSkyPlanCard">
            <v-divider/>
            <v-radio-group v-model="currentPlan" class="px-3 max-height">
              <template v-for="plan in activeGreenskyPlans">
                <div :key="plan.id">
                  <PaymentEstimatorCard
                    :key="plan.id"
                    :plan="plan"
                    :loanTotal="moneyInt(loanAmount)"
                  />
                  <v-divider/>
                </div>
              </template>
            </v-radio-group>
          </v-card>

          <!-- Works same way as showPlanCard, but for Wells Fargo -->
          <v-card v-if="showWellsFargoPlanCard && item.id === 'wellsfargo'">
            <v-divider/>  
            <div>                  
              <FanLoader
                :loading="loading"
                :error="error"
              />
                <div v-if="loading" slot="loadingMsg" class="full-width text-xs-center body-2 my-2 pb-3" >
                    Calculating Plans...
                </div>
                <div v-html="message" v-if="error" slot="error"  class="full-width text-xs-center body-2 my-2 pb-3" >
                </div>
            </div>
            <v-radio-group v-if="!error && !loading" v-model="currentPlan" class="px-3 max-height">
              <template v-for="plan in wellsfargoCalculatedPlans">
                <div :key="plan.id">
                  <PaymentEstimatorCard
                    :key="plan.id"
                    :plan="plan"
                    :loanTotal="moneyInt(loanAmount)"
                    wellsfargoCheck
                  />
                  <v-divider/>
                </div>
              </template>
            </v-radio-group>
          </v-card>

          <!-- Works same way as showPlanCard, but for marlin -->
          <v-card v-if="showMarlinPlan">
            <v-divider/>
            <v-radio-group v-model="currentPlan" class="px-3 max-height">
              <template  v-for="plan in marlinPlans">
                <div :key="plan.id">
                  <!-- Passing down marlinCheck as a way to activate Marlin-specific function in PaymentEstimatorCard -->
                  <PaymentEstimatorCard
                    :key="plan.planNumber"
                    :plan="plan"
                    :loanTotal="moneyInt(loanAmount)"
                    marlinCheck
                  />
                  <v-divider/>
                </div>
              </template>
            </v-radio-group>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
  import LenderListTile from 'Components/LenderListTile.vue'
  import PaymentEstimatorCard from 'Components/PaymentEstimatorCard.vue'
  import FanLoader from 'Components/FanLoader.vue'
  import { mapGetters, mapActions, mapState } from 'vuex'
  import { formDataPageOne } from 'Helpers/CreditApplicationFormHelper.js'
  import { wellsFargoPaymentCalculator } from 'Helpers/c4cAPIClient'
  import { greensky, fortiva, marlin, wellsfargo } from 'Helpers/lenders'
  //Here are the details for the marlin plans. Not calling conduit for data, but storing it in planUtils
  import { marlinPlans} from '@/helpers/plansUtils'


  export default {
    name: 'financing-options',
    components: {
      LenderListTile,
      FanLoader,
      PaymentEstimatorCard,
    },
    props: {
      loanAmount: String,
    },
    data () {
      return {
        //Changed from '' to 'Prime', otherwise no plans propogate unless
        //you click a tab
        activeTab: '',
        showLenders: false,
        currentLender: '',
        currentPlan: '',
        marlinPlans,
        options: [
          {
            label: 'Prime',
            id: 'prime',
            lender: greensky
          },
          {
            label: '2nd Look',
            id: 'second_look',
            lender: fortiva
          },
          {
            label: 'Business-Lender',
            id: 'business_lender',
            lender: marlin
          },
          {
            label: 'Wells Fargo',
            id: 'wells_fargo',
            lender: wellsfargo
          },
        ],
        formDataPageOne,
        valid: true,
        paceInfo: {},
        error: null,
        message: null,
        loading: false,
        mounted: false,
        wellsfargoCalculatedPlans: {},
      }
    },
    computed: {
      ...mapState({
        isEasyLinkUser: state => state.easyLink.active,
      }),
      ...mapGetters(['greenskyPlans', 'wellsfargoPlans', 'availableLenders', 'moneyInt']),
      availableOptions() {
        let options = []

        this.availableLenders.filter(lender => lender.active).forEach(l => {
          if (l.lender_id === '1') {
            options.push({
              label: 'Prime',
              id: 'prime',
              lender: greensky,
              merchantId: l.merchant_id,
              lender_id: '1'
            })
          } else if (l.lender_id === '2') {
            options.push({
              label: '2nd Look',
              id: 'second_look',
              lender: fortiva,
              merchantId: l.merchant_id,
              lender_id: '2'
            })
          } else if (l.lender_id === '5') {
            options.push({
              label: 'Business-Lender',
              id: 'business',
              lender: marlin,
              merchantId: l.merchant_id,
              lender_id: '5'
            })
          } else if (l.lender_id === '7') {
            options.push({
              label: 'Wells-Fargo',
              id: 'wellsfargo',
              lender: wellsfargo,
              merchantId: l.merchant_id,
              lender_id: '7'
            })
          }
        }) 

        let result = []
        // Order available lenders in the order they need to be displayed
        const lendersOrder = [ "wellsfargo", "greensky", "fortiva", "marlin"];
        lendersOrder.forEach(lender => {
          options.filter(item =>{
            if(lender === item.lender.id){
              result.push(item)
            }
          })
        })

        return result
      },
      activeGreenskyPlans() {
        return this.greenskyPlans.filter(plan => plan.isActive)
      },
      showGreenSkyPlanCard () {
        //TODO review lender logic
        return !this.showLenders &&
          this.currentLender.id === 'greensky'
      },
      //using to display a custom card for Marlin financing options
      showMarlinPlan() {
        return !this.showLenders && this.currentLender.id==='marlin'
      },
      showWellsFargoPlanCard() {
        return !this.showLenders && this.currentLender.id==='wellsfargo'
      },
    },
    watch: {
      activeTab () {
        //changed from this.mounted. Otherwise, GreenSky TabItem
        //persists for 1 extra tab, even when clicking another lender Tab
        //(ie: if you click Fortiva, the Greensky Financing plans show up) 
        if (!this.mounted) {
          this.clearPlan()
          switch (this.activeTab) {
            case 'Prime':
              this.currentLender = this.options[0].lender
              break
            case '2nd Look':
              this.currentLender = this.options[1].lender
              break
            case 'Business-Lender':
              this.currentLender = this.options[2].lender
              break
            case 'Wells-Fargo':
              this.currentLender = this.options[3].lender 
              break  
          }
          this.showLenders = false
        } else {
          this.mounted = true
        }
      },
      currentLender () {
        this.setLender(this.currentLender)
        if (this.currentLender.id) {
          this.showLenders = false
        }
        // If user switches to Wells Fargo and there's a loan amount already present, log it here for now:
        if (this.currentLender.id === "wellsfargo") {
          if (this.moneyInt(this.loanAmount) !== 0  && this.moneyInt(this.loanAmount) > 999 ) {
            this.runWellsFargoPaymentCalculcations(this.loanAmount)
          }
        }
      },
      currentPlan () {
        this.setLoanPlan(this.currentPlan)
      },
      async loanAmount(newTotal, oldTotal) {
        if (this.currentLender.id === "wellsfargo" && this.moneyInt(this.loanAmount) > 999 ) {
          this.runWellsFargoPaymentCalculcations(newTotal)
        }
      },
      showLenders () {
        if (this.showLenders === true) {
          this.clearPlanAndLender()
        }
      }
    },
     async created () {
       //Calling getUserInfo again here since we've moved almost all of
       //user state out of vuex persist
       //Because  easylink users end up viewing this component when they use the comfort button
       //getUserInfo will return a 404. So we only run this function if this is an 'in app'
       //user, aka: not an easy link user.
      if(!this.isEasyLinkUser){
      await this.getUserInfo()
      }
      this.setLoanPlan('')
      this.currentLender = this.getLender(
        this.availableOptions[0].lender_id
      ).lender
      this.activeTab=this.getLender(this.availableOptions[0].lender_id).label
    },
    mounted () {
      //Moving to created until we can integrage all of state.user into 
      //vuex persist again
      // this.currentLender = this.getLender(
      //   this.availableLenders[0].lender_id
      // ).lender
    },
    methods: {
      ...mapActions([
        'setLoanPlan',
        'setLender',
        'getUserInfo'
      ]),
      getMerchantId(lenderId) {
        const option = this.availableOptions
          .filter( l => l.id === lenderId )
          .pop()
        return option.merchantId
      },
      async runWellsFargoPaymentCalculcations(amt) {
        if (this.error) {
          this.error = null
        }
        this.loading = true
        const plans = []
        const plansAmountNotMet = []
        this.wellsfargoPlans.forEach((plan)=>{
          if(plan.minLoanAmount <= this.moneyInt(amt)){
            plans.push(plan)
          } else {
            plansAmountNotMet.push(plan)
          }
        })

        await wellsFargoPaymentCalculator({
          "merchantNumber": this.getMerchantId(this.currentLender.id),
          "requestedCreditLimit": this.moneyInt(amt),
          "plans": plans.map(plan => plan.planNumber)
        })
        .then(data => {
          const calculatedPlans = data.data.paymentCalculations
          const combinedPlanInfo = calculatedPlans.map(cp => {
            const i = plans.find(p => p.planNumber === cp.planNumber)
            cp.id = i.id
            cp.minLoanAmount = i.minLoanAmount
            return cp
          })

        this.wellsfargoCalculatedPlans = [...combinedPlanInfo, ...plansAmountNotMet]
        })
        .catch(err => {
          this.error = true
          if (this.wellsfargoPlans.length < 1) {
            return this.message = `No Plans Selected. You can configure plans <a href="/integrations-hub">here.</a>`
          }
          return this.message = err
        })
        this.loading = false
      },
      noLenderSelected () {
        this.currentLender = {
          companyLogo: null,
          name: 'No Lender Selected'
        }
      },
      clearPlan () {
        this.currentPlan = {}
      },
      clearPlanAndLender () {
        this.noLenderSelected()
        this.clearPlan()
      },
      saveLender (lender) {
        this.currentLender = lender
      },
      setPlan (plan) {
        this.currentPlan = plan
      },
      getLender(id) {
        switch(id) {
          case '1':
            return this.options[0]
          case '2':
            return this.options[1]
          case '5':
            return this.options[2]
          case '7':
            return this.options[3]    
          default:
            return null
        }
      },
    },
  }
</script>

<style lang="scss">
  .expansion-panel__header {
    padding: 0!important;
    margin-left: 4px!important;
    margin-right: 4px!important;
  }

  .list__tile--avatar {
    padding-right: 0!important;
  }

  .radio-group--column {
    padding-top: 0!important;

    .input-group__details {
      min-height: 0px!important;
    }
  }

  .disclaimer {
    text-align: left;
  }

  @media (max-width: 375px) {
    .feature {
      font-size: small !important;
    }
  }
</style>
